/**
 * region for libraries*/
import React, { Component, Fragment } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {
  Paper,
  TableContainer,
  TableBody,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableSortLabel,
  Link,
  TablePagination,
  Checkbox,
  Chip,
  Button,
  Menu,
  MenuList,
  MenuItem,
  Popover,
  LinearProgress,
  TextField,
} from "@material-ui/core";

/**
 * region for redux*/
import { connect } from "react-redux";
import { IdentifySupplierJobsActions } from "../../actions/IdentifySupplierJobsActions";

/**
 * region for styles*/
import { identifySupplierJobsStyle } from "./style/identifySupplierJobsStyle";

/**
 * region for componets*/
import TextResponse from "../../components/common/TextResponse";

/**
 * region for hepers*/
import ajax from '../../helpers/ajax';
import Constants from "../../constants/Constants";
import typing from "../../helpers/typing";

import { ArrowDropDown } from "@material-ui/icons";

class IdentifySupplierJobs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mode: Constants.MODE_LOADED,
      rowsPerPage: 10,
      order: "asc",
      orderBy: "companyId",
      anchorEl: null,
      contextTableMenuX: null,
      contextTableMenuY: null,
      contextTableMenuShow: false,
      contextTableMenuItem: null,
      paramsForDiscarded: {},
      openModalDiscarded: false,
      reasonDiscardedSelected: null,
      backofficeUrlBase: []
    };
  } 
  componentDidMount() {
    this.load();
    this.props.GetReasonsForDiscarded();
  }

  load() {
    const self = this;

    ajax.get(Constants.ROUTE_API_COMMONDATA,
        {
            success: function (response) {
                self.setState({
                    backofficeUrlBase: response.data.urlBackofficeBase,
                    mode: Constants.MODE_LOADED
                });
            }
        });
  } 

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: parseInt(event.target.value, 10) }, () => {
      this.props.setPage(this.state.page);
    });
  };

  handleChangePage = (event, newPage) => {
    this.props.setPage(newPage);
  };

  handleRequestSort = (event, property) => {
    this.props.setSelectedList([]);
    const isAsc = this.state.orderBy === property && this.state.order === "asc";
    this.setState({ order: isAsc ? "desc" : "asc", orderBy: property });
  };

  stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  getComparator(order, orderBy) {
    return order === "desc" ? (a, b) => this.descendingComparator(a, b, orderBy) : (a, b) => -this.descendingComparator(a, b, orderBy);
  }

  descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  headerTableRow() {
    return [
      {
        id: "Domain",
        numeric: false,
        disablePadding: false,
        label: "URL",
        minWidth: 365,
        width: "auto",
      },
      {
        id: "Location",
        numeric: false,
        disablePadding: false,
        label: "Location",
        minWidth: 265,
        maxWidth: 265,
        width: 265,
      },
      {
        id: "ResearchedKeyword",
        numeric: false,
        disablePadding: false,
        label: "Researched Keyword",
        minWidth: 265,
        maxWidth: 265,
        width: 265,
      },
      {
        id: "Category",
        numeric: false,
        disablePadding: false,
        label: "Category",
        minWidth: 300,
        maxWidth: 300,
        width: 300,
      },
      {
        id: "EndDate",
        numeric: false,
        disablePadding: false,
        label: "Date",
        minWidth: 130,
        maxWidth: 130,
        width: 130,
      },
      {
        id: "Score",
        numeric: false,
        disablePadding: false,
        label: "Score",
        minWidth: 95,
        maxWidth: 95,
        width: 95,
      },
      {
        id: "STATUS",
        numeric: false,
        disablePadding: false,
        label: "Status",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
    ];
  }

  handleOnSelectAllClick(event) {
    let self = this;
    self.props.setSelectedList([]);
    if (event.target.checked) {
      let order = self.state.order;
      let orderBy = self.state.orderBy;
      let cloneList=[...self.props.resultList.data]
      let newlistSelected = self.stableSort(cloneList, self.getComparator(order, orderBy))
      .splice((this.state.rowsPerPage*this.props.page),this.state.rowsPerPage);     
      self.props.setSelectedList(newlistSelected);
    } 
  }

  handleOnClickCheckbox(event) {
    event.stopPropagation();
    return;
  }

  handleOnClickLink(event) {
    event.stopPropagation();
    return;
  }

  handleOnChangeCheckbox(row, event) {
    let self = this;
    self.props.setSelectedList([]);
    let newlistSelected = [...self.props.selectedList];
    if (event.target.checked) {
      newlistSelected.push(row);
    } else {
      let index = newlistSelected.findIndex((item) => item.IdIdentifySupplierJob === row.IdIdentifySupplierJob);
      if (index !== -1) {
        newlistSelected.splice(index, 1);
      }
    }
    self.props.setSelectedList(newlistSelected);
  }

  handleOnClickRow(row, event) {
    let self = this;
    if (row != null) {
      self.props.setSelectedRow(row);
    }
  }

  handleOnContextMenuRow(row, event) {
    event.preventDefault();
    let self = this;
    if (row != null) {
      self.setState({
        contextTableMenuX: event.clientX,
        contextTableMenuY: event.clientY,
        contextTableMenuShow: true,
        contextTableMenuItem: row,
      });
    }
  }

  handleOnCloseMenuRow(event) {
    event.preventDefault();
    this.setState({
      contextTableMenuX: null,
      contextTableMenuY: null,
      contextTableMenuShow: false,
      contextTableMenuItem: null,
    });
  }

  handleOnClickIconButtonStatus(item, status, event, reasonDiscardedSelected) {
    if (event){
      event.stopPropagation();
    }
    let self = this;
    var KeyValue = [[item.IdIdentifySupplierJob, item.Url]];
    const obj = Object.fromEntries(KeyValue);
    let requestData = {
      IdStatus: status,
      KeyValues: obj,
      IdReasonDiscarded: reasonDiscardedSelected !== undefined ? reasonDiscardedSelected.IdReasonDiscarded : null
    };
    let selectedList = [...self.props.selectedList];
    selectedList.push(item);
    this.props.setStatusChangeList(this.props.resultList, requestData, selectedList);

    this.setState({
      contextTableMenuX: null,
      contextTableMenuY: null,
      contextTableMenuShow: false,
      contextTableMenuItem: null,
    });
  }

  handleOnClickMenuStatusSelectedMultiple(status, event, reasonDiscardedSelected) {
    let self = this;
    if (event){
      event.stopPropagation();
    }
    var KeyValue = new Map(this.props.selectedList.map((i) => [i.IdIdentifySupplierJob, i.Url]));
    const obj = Object.fromEntries(KeyValue);
    let requestData = {
      IdStatus: status,
      KeyValues: obj,
      IdReasonDiscarded: reasonDiscardedSelected !== undefined ? reasonDiscardedSelected.IdReasonDiscarded : null
    };
    self.setState({ anchorEl: null }, function () {
      self.props.setStatusChangeList(this.props.resultList, requestData, this.props.selectedList);
    });
  }

  showModalDiscarded(item, status, event) {
    let self = this;
    this.setState({
      openModalDiscarded: true,
      paramsForDiscarded: {
        item: item,
        status: status,
        event: null
      },
      reasonDiscardedSelected: null
    });

    self.handleOnCloseMenuRow(event);
    self.handleOnCloseMenuStatus(event);
  }

  closeModalDiscarded(discard) {
    let self = this;
    self.setState({ openModalDiscarded: false });

    if (discard) {
      let paramsForDiscarded = self.state.paramsForDiscarded;
      let reasonDiscardedSelected = self.state.reasonDiscardedSelected;

      if (paramsForDiscarded.item != null){
        self.handleOnClickIconButtonStatus(paramsForDiscarded.item, paramsForDiscarded.status, paramsForDiscarded.event, reasonDiscardedSelected);
      }
      else if (this.props.selectedList.length > 0){
        self.handleOnClickMenuStatusSelectedMultiple(paramsForDiscarded.status, paramsForDiscarded.event, reasonDiscardedSelected);
      }
    }
  }

  handleOnChangeReasonDiscarded(event, item){
    let self = this;
    if (!typing.isEmpty(item)){
      self.setState({ reasonDiscardedSelected: item });
    }
    else{
      self.setState({ reasonDiscardedSelected: null });
    }
  }

  handleOnClickMenuStatus(event) {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleOnCloseMenuStatus(event) {
    this.setState({ anchorEl: null });
  }

  render() {
    let self = this;
    const { classes, resultList, page, selectedList, filters, filtersPending, reasonsForDiscarded } = this.props;
    let tableTotalRows = Object.keys(resultList).length > 0 ? resultList.data.length : 0;

    let tableTotalRowsSelect = Object.keys(selectedList).length > 0 ? selectedList.length : 0;

    let tableRows, tableHeader, modalDiscarded;
    let openModalDiscarded = self.state.openModalDiscarded;
    let reasonDiscardedSelected = self.state.reasonDiscardedSelected;
    let order = self.state.order;
    let orderBy = self.state.orderBy;
    let rowsPerPage = self.state.rowsPerPage;

    let emptyRows = rowsPerPage - Math.min(rowsPerPage, tableTotalRows - page * rowsPerPage);
    let rowsInPage = rowsPerPage-emptyRows;
    
    const openPopover = Boolean(this.state.anchorEl);
    const idPopover = openPopover ? "simple-popover-status" : undefined;

    let approved = Constants.SUPPLIER_JOB_STATUS.find((x) => x.id === Constants.SUPPLIER_JOB_STATUS_ENUM.Approved);
    let discarded = Constants.SUPPLIER_JOB_STATUS.find((x) => x.id === Constants.SUPPLIER_JOB_STATUS_ENUM.Discarded);
    tableHeader = (
      <TableHead>
        <TableRow>
          <TableCell align="left" className={classes.tableCellCheckbox}>
            <div className={classes.containerCheckboxMenu}>
              <Fragment>
                <Checkbox
                  indeterminate={tableTotalRowsSelect > 0 && tableTotalRowsSelect < rowsInPage}
                  color="default"
                  checked={tableTotalRows > 0 && tableTotalRowsSelect === rowsInPage}
                  onChange={this.handleOnSelectAllClick.bind(this)}
                  inputProps={{ "aria-label": "select all" }}
                  className={classes.checkboxHeader}
                  disabled={tableTotalRows > 0 ? false : true}
                />
                <Button
                  aria-describedby={idPopover}
                  variant="outlined"
                  className={classes.arrowDropDown}
                  onClick={this.handleOnClickMenuStatus.bind(this)}
                  disabled={
                    tableTotalRows > 0 &&
                    (filters.idStatus === Constants.SUPPLIER_JOB_STATUS_ENUM.New ||
                      filters.idStatus === Constants.SUPPLIER_JOB_STATUS_ENUM.Discarded ||
                      filters.idStatus === Constants.SUPPLIER_JOB_STATUS_ENUM.Error)
                      ? false
                      : true
                  }
                >
                  <ArrowDropDown />
                </Button>
                <Popover
                  id={idPopover}
                  open={openPopover}
                  anchorEl={this.state.anchorEl}
                  onClose={this.handleOnCloseMenuStatus.bind(this)}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                >
                  {filters.idStatus === Constants.SUPPLIER_JOB_STATUS_ENUM.New && (
                    <MenuList>
                      <MenuItem onClick={this.handleOnClickMenuStatusSelectedMultiple.bind(this, approved.id)}>{approved.value}</MenuItem>
                      <MenuItem onClick={this.showModalDiscarded.bind(this, null, discarded.id)}>{discarded.value}</MenuItem>
                      <MenuItem onClick={this.handleOnClickMenuStatusSelectedMultiple.bind(this, Constants.ProcessAgain)}>Process again</MenuItem>
                    </MenuList>
                  )}
                  {filters.idStatus === Constants.SUPPLIER_JOB_STATUS_ENUM.Discarded ||
                    (filters.idStatus === Constants.SUPPLIER_JOB_STATUS_ENUM.Error && (
                      <MenuList>
                        <MenuItem onClick={this.handleOnClickMenuStatusSelectedMultiple.bind(this, Constants.ProcessAgain)}>Process again</MenuItem>
                      </MenuList>
                    ))}
                </Popover>
              </Fragment>
            </div>
          </TableCell>
          {self.headerTableRow().map((headCell) => (
            <TableCell
              component="th"
              scope="row"
              width={headCell.width}
              style={{
                minWidth: headCell.minWidth,
                maxWidth: headCell.maxWidth,
              }}
              key={headCell.id}
              align={headCell.numeric ? "right" : "left"}
              padding={headCell.disablePadding ? "none" : "default"}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={(event) => self.handleRequestSort(event, headCell.id)}
              >
                <span className={classes.tableCellLabel}>{headCell.label}</span>
                {orderBy === headCell.id ? <span className={classes.visuallyHidden}>{order === "desc" ? "sorted descending" : "sorted ascending"}</span> : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
        {this.props.resultListPeding && (
          <TableRow>
            <TableCell colSpan={9} style={{ padding: 0, height: "2px" }}>
              <LinearProgress variant="indeterminate" style={{ height: "2px" }} />
            </TableCell>
          </TableRow>
        )}
      </TableHead>
    );

    if (Object.keys(resultList).length > 0) {
      tableRows = self
        .stableSort(resultList.data, self.getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map((item, index) => {
          var isCheked = false;
          if (Object.keys(selectedList).length > 0) {
            isCheked = selectedList.some((itemSelect) => item.IdIdentifySupplierJob === itemSelect.IdIdentifySupplierJob);
          }

          let label;
          if (Constants.SUPPLIER_JOB_STATUS.some((d) => d.id === item.IdStatus)) {
            let labelStatus = Constants.SUPPLIER_JOB_STATUS.find((x) => x.id === item.IdStatus);
            label = <Chip color={labelStatus.background} label={labelStatus.value} size="small" className={classes.chipLabel} />;
          }
          return (
            <TableRow key={index} hover onClick={this.handleOnClickRow.bind(this, item)} onContextMenu={this.handleOnContextMenuRow.bind(this, item)}>
              <TableCell align="left">
                <Checkbox
                  className={classes.checkboxHeader}
                  color="default"
                  checked={isCheked}
                  onChange={this.handleOnChangeCheckbox.bind(this, item)}
                  onClick={this.handleOnClickCheckbox.bind(this)}
                />
              </TableCell>
              <TableCell align="left">
                <div className={classes.textCompany}>
                  { !typing.isEmpty(item.Company) && <span className="mr-1">{item.Company}</span> }
                  { item.ResearchType === Constants.RESEARCHTYPES.Organic && <Chip label="Organic" color="primary" style={{ height: "16px", marginRight: "3px"  }} /> }
                  { item.ResearchType === Constants.RESEARCHTYPES.Paid && <Chip label="Paid" color="secondary" style={{ height: "16px", marginRight: "3px"  }} /> }
                  { item.Repeated === true && <Chip label="Duplicated" color="secondary" style={{ height: "16px" }} /> }
                </div>
                {
                  !typing.isEmpty(item.Snippet) && 
                  <span className={classes.textSnippet}>{item.Snippet}</span>
                }
                <Link className={classes.textLink} href={item.Url} target="_blank" rel="noopener" onClick={this.handleOnClickLink.bind(this)}>
                  {item.Domain}
                </Link>
              </TableCell>
              <TableCell align="left">{item.Location}</TableCell>
              <TableCell align="left">
                <div className={classes.textCategory}>{item.ResearchedKeyword}</div>
              </TableCell>
              <TableCell align="left">
                <div className={classes.textCategory}>{item.Category}</div>
              </TableCell>
              <TableCell align="left">{!typing.isEmpty(item.EndDate) ? typing.convertToDateShortMonth(item.EndDate) : ""}</TableCell>
              <TableCell align="left">
                <div className={classes.text60}>{item.Score}</div>
              </TableCell>
              <TableCell align="left">{label}</TableCell>
            </TableRow>
          );
        });
    }

    modalDiscarded = (
      <Modal isOpen={openModalDiscarded} className="modal-lg">
        <ModalHeader>Select the reason for discard</ModalHeader>
        <ModalBody className="text-center font-size-xl">
          <Autocomplete
            id="combo-box-demo"
            disableListWrap={true}
            disableClearable={false}
            autoComplete={false}
            options={reasonsForDiscarded}
            getOptionLabel={(option) => option.Description}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select a reason for discard"
                variant="outlined"
                size="small"
                fullWidth
                required
              />
            )}
            onChange={this.handleOnChangeReasonDiscarded.bind(this)}
          />
        </ModalBody>
        <ModalFooter>
            <Button color="primary" onClick={this.closeModalDiscarded.bind(this, true)} disabled={reasonDiscardedSelected == null}>Discard</Button>{' '}
            <Button color="secondary" onClick={this.closeModalDiscarded.bind(this, false)}>Cancel</Button>
            </ModalFooter>
      </Modal>
    );

    return (
      <Paper className={classes.paper} elevation={0} square={false} variant="outlined">
        {!filtersPending && (
          <Fragment>
            <TableContainer>
              <Table className={classes.table} size={"small"} aria-label="caption table">
                {tableHeader}
                {tableTotalRows > 0 && !this.props.resultListPeding && (
                  <TableBody>
                    {tableTotalRows > 0 && <Fragment>{tableRows}</Fragment>}
                    {tableTotalRows > 0 && emptyRows > 0 && (
                      <TableRow style={{ height: 44 * emptyRows }}>
                        <TableCell colSpan={9} />
                      </TableRow>
                    )}
                  </TableBody>
                )}
                {tableTotalRows === 0 && !this.props.resultListPeding && (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={9}>
                        <TextResponse text="Sorry, no matching records found" />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 15, 20, 50]}
              component="div"
              count={tableTotalRows}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={self.handleChangePage}
              onChangeRowsPerPage={self.handleChangeRowsPerPage}
            />

            {self.state.contextTableMenuItem != null && self.state.contextTableMenuItem.IdStatus === Constants.SUPPLIER_JOB_STATUS_ENUM.New && (
              <Menu
                keepMounted
                open={self.state.contextTableMenuShow}
                onClose={self.handleOnCloseMenuRow.bind(this)}
                anchorReference="anchorPosition"
                anchorPosition={
                  self.state.contextTableMenuY !== null && self.state.contextTableMenuX !== null
                    ? { top: self.state.contextTableMenuY, left: self.state.contextTableMenuX }
                    : undefined
                }
              >
                <MenuItem onClick={this.handleOnClickIconButtonStatus.bind(this, self.state.contextTableMenuItem, approved.id)}>{approved.value}</MenuItem>
                <MenuItem onClick={this.showModalDiscarded.bind(this, self.state.contextTableMenuItem, discarded.id)}>{discarded.value}</MenuItem>
                <MenuItem onClick={this.handleOnClickIconButtonStatus.bind(this, self.state.contextTableMenuItem, Constants.ProcessAgain)}>
                  Process again
                </MenuItem>
              </Menu>
            )}
            {filters.idStatus === Constants.SUPPLIER_JOB_STATUS_ENUM.Discarded ||
              (filters.idStatus === Constants.SUPPLIER_JOB_STATUS_ENUM.Error && (
                <Menu
                  keepMounted
                  open={self.state.contextTableMenuShow}
                  onClose={self.handleOnCloseMenuRow.bind(this)}
                  anchorReference="anchorPosition"
                  anchorPosition={
                    self.state.contextTableMenuY !== null && self.state.contextTableMenuX !== null
                      ? { top: self.state.contextTableMenuY, left: self.state.contextTableMenuX }
                      : undefined
                  }
                >
                  <MenuItem onClick={this.handleOnClickIconButtonStatus.bind(this, self.state.contextTableMenuItem, Constants.ProcessAgain)}>
                    Process again
                  </MenuItem>
                </Menu>
              ))}
          </Fragment>
        )}
        {modalDiscarded}
      </Paper>
    );
  }
}

IdentifySupplierJobs.propTypes = {
  classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const resultList = state.IdentifySupplierJobsReducers.resultList;
  const resultListPeding = state.IdentifySupplierJobsReducers.resultListPeding;
  const page = state.IdentifySupplierJobsReducers.page;
  const selectedList = state.IdentifySupplierJobsReducers.selectedList;
  const filters = state.IdentifySupplierJobsReducers.filters;
  const filtersPending = state.IdentifySupplierJobsReducers.filtersPending;
  const reasonsForDiscarded = state.IdentifySupplierJobsReducers.reasonsForDiscarded;
  return {
    resultList,
    resultListPeding,
    page,
    selectedList,
    filters,
    filtersPending,
    reasonsForDiscarded,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    setPage: (page) => dispatch(IdentifySupplierJobsActions.setPage(page)),
    setSelectedList: (selectedList) => dispatch(IdentifySupplierJobsActions.setSelectedList(selectedList)),
    setSelectedRow: (selectedRow) => dispatch(IdentifySupplierJobsActions.setSelectedRow(selectedRow)),
    setStatusChangeList: (resultList, statusChangeList, selectedList) =>
      dispatch(IdentifySupplierJobsActions.setStatusChangeList(resultList, statusChangeList, selectedList)),
    GetReasonsForDiscarded: () => dispatch(IdentifySupplierJobsActions.GetReasonsForDiscarded())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(identifySupplierJobsStyle)(IdentifySupplierJobs));
